import * as types from "../../actions/actionTypes";
const initialState = {
  loading: true,
  removeLoading: false,
  inProcess: false,
  data: { data: [], links: {}, message: [], meta: {} },
  selected: {},
  error: "",
  imagesLoading: true,
  imagesError: "",
  images: []
};

const PettyCashierPayment = (state = initialState, action) => {
  switch (action.type) {
    case types.PETTY_CASHIER_REMOVE_PAYMENT_REQUEST:
      return { ...state, removeLoading: true, loading: true };
    case types.PETTY_CASHIER_REMOVE_PAYMENT_SUCCESS:
      return {
        ...state,
        ...action.payLoad,
        removeLoading: false,
        loading: false
      };
    case types.PETTY_CASHIER_REMOVE_PAYMENT_FAILURE:
      return {
        ...state,
        ...action.payLoad,
        removeLoading: false,
        loading: false
      };

    case types.PETTY_CASHIER_GET_IMAGE_PAYMENT_REQUEST:
      return { ...state, imagesLoading: true, imagesError: "" };
    case types.PETTY_CASHIER_GET_IMAGE_PAYMENT_SUCCESS:
      return { ...state, images: action.payLoad, imagesLoading: false };
    case types.PETTY_CASHIER_GET_IMAGE_PAYMENT_FAILURE:
      return { ...state, imagesLoading: false, imagesError: action.error };

    case types.PETTY_CASHIER_STORE_PAYMENT_REQUEST:
      return { ...state, inProcess: true };
    case types.PETTY_CASHIER_STORE_PAYMENT_SUCCESS:
      return { ...state, inProcess: false };
    case types.PETTY_CASHIER_STORE_PAYMENT_FAILURE:
      return { ...state, inProcess: false };

    case types.PETTY_CASHIER_UPDATE_PAYMENT_REQUEST:
      return { ...state, inProcess: true };
    case types.PETTY_CASHIER_UPDATE_PAYMENT_SUCCESS:
      return { ...state, inProcess: false };
    case types.PETTY_CASHIER_UPDATE_PAYMENT_FAILURE:
      return { ...state, inProcess: false };

    case types.PETTY_CASHIER_GET_PAYMENT_REQUEST:
      return { ...state, loading: true, error: "", selected: {} };
    case types.PETTY_CASHIER_GET_PAYMENT_SUCCESS:
      return { ...state, selected: action.payLoad, loading: false };
    case types.PETTY_CASHIER_GET_PAYMENT_FAILURE:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};

export default PettyCashierPayment;
